var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 0.500079C18.3687 1.06298 17.4851 1.4935 16.55 1.77508C16.0482 1.198 15.3812 0.788989 14.6392 0.603351C13.8973 0.417713 13.1163 0.464409 12.4018 0.737123C11.6873 1.00984 11.0737 1.49541 10.6442 2.12818C10.2146 2.76094 9.98979 3.51036 10 4.27508V5.10841C8.53557 5.14639 7.08444 4.82159 5.77588 4.16295C4.46733 3.50431 3.34197 2.53228 2.50004 1.33341C2.50004 1.33341 -0.833293 8.83341 6.66671 12.1667C4.95048 13.3317 2.906 13.9159 0.833374 13.8334C8.33337 18.0001 17.5 13.8334 17.5 4.25008C17.4993 4.01796 17.477 3.78641 17.4334 3.55841C18.2839 2.71966 18.8841 1.66067 19.1667 0.500079Z",
    fill: "#07070C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b9f099b44270aafb972987c9d59ab37e.svg";
export { ForwardRef as ReactComponent };